/* ============================================================
   Billetterie Équipe de France — JS unique, vanilla, différé
   Compte à rebours · menu mobile · header sticky · accordéon
   sélecteur de variantes · CTA d'achat sticky · révélations
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Compte à rebours ---------- */
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function tick(el){
    var deadline = new Date(el.getAttribute('data-deadline')).getTime();
    var diff = deadline - Date.now();
    var cells = el.querySelectorAll('[data-unit]');
    if (diff <= 0){ cells.forEach(function(c){ c.textContent = '00'; }); return false; }
    var s = Math.floor(diff/1000);
    var d = Math.floor(s/86400); s -= d*86400;
    var h = Math.floor(s/3600); s -= h*3600;
    var m = Math.floor(s/60); s -= m*60;
    var map = { days:d, hours:pad(h), mins:pad(m), secs:pad(s) };
    cells.forEach(function(c){ var u=c.getAttribute('data-unit'); if(map[u]!==undefined) c.textContent = map[u]; });
    return true;
  }
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    if (!el.getAttribute('data-deadline')) return;
    tick(el);
    var id = setInterval(function(){ if(!tick(el)) clearInterval(id); }, 1000);
  });

  /* ---------- Header sticky (change d'état au scroll) ---------- */
  var header = document.querySelector('.site-header');
  if (header){
    var onScroll = function(){ header.classList.toggle('is-stuck', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive:true });
  }

  /* ---------- Menu mobile ---------- */
  var burger = document.querySelector('.burger');
  var menu = document.querySelector('.mobile-menu');
  if (burger && menu){
    var closeBtn = menu.querySelector('.close');
    var open = function(){ menu.classList.add('open'); document.body.style.overflow='hidden'; burger.setAttribute('aria-expanded','true'); };
    var close = function(){ menu.classList.remove('open'); document.body.style.overflow=''; burger.setAttribute('aria-expanded','false'); };
    burger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    menu.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('a')) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  }

  /* ---------- Produit : variantes, plan du stade, placement, CTA ---------- */
  var pform = document.querySelector('.js-product-form');
  if (pform){
    var data = {};
    var dataEl = pform.querySelector('.variant-data');
    try { data = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch(e){}
    var idInput = pform.querySelector('input[name="id"]');
    var qtyInput = pform.querySelector('input[name="quantity"]');
    var priceEls = document.querySelectorAll('[data-live-price]');
    var submitBtns = document.querySelectorAll('[data-add]');
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var map = document.querySelector('.stadium__map');
    var zones = map ? Array.prototype.slice.call(map.querySelectorAll('.zone')) : [];
    var legend = Array.prototype.slice.call(document.querySelectorAll('.stadium__legend li'));
    var seatBox = document.querySelector('[data-seatinfo]');
    var seatGrid = document.querySelector('[data-seatinfo-grid]');
    var props = {};
    ['Section','Level','Gate','Block','Row','Seats'].forEach(function(k){ props[k] = pform.querySelector('input[name="properties['+k+']"]'); });

    var SEATS = {
      'golden circle': {tribune:'Golden Circle — Center Front', niveau:'Floor', porte:'H'},
      'category 1':    {tribune:'West Stand — Lower Side', niveau:'Lower tier', porte:'E'},
      'category 2':    {tribune:'East Stand — Lower Side', niveau:'Lower tier', porte:'P'},
      'category 3':    {tribune:'North End', niveau:'Lower tier', porte:'A'},
      'category 4':    {tribune:'South End', niveau:'Upper tier', porte:'T'}
    };
    var rnd = function(a,b){ return Math.floor(Math.random()*(b-a+1))+a; };
    var money = function(cents){ return (cents/100).toLocaleString('en-US',{style:'currency',currency:currency}); };
    var currentRadio = function(){ return pform.querySelector('input[name="variant-radio"]:checked'); };
    var catOf = function(r){ if(!r) return ''; var l=pform.querySelector('label[for="'+r.id+'"] .oname'); return l?l.textContent.trim():''; };
    var srow = function(k,v){ return '<div class="si-row"><span>'+k+'</span><b>'+v+'</b></div>'; };

    var updateTotals = function(){
      var r = currentRadio(); if(!r || !data[r.value]) return;
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value,10)||1);
      var tEl = document.querySelector('[data-total]');
      var subEl = document.querySelector('[data-total-sub]');
      if(tEl) tEl.textContent = money(data[r.value].price * qty);
      if(subEl) subEl.textContent = qty + (qty>1 ? ' tickets ' : ' ticket ') + '× ' + money(data[r.value].price);
    };

    var seatState = null;
    var assignSeats = function(){
      var r = currentRadio(); if(!r) return;
      var cat = catOf(r), key = cat.toLowerCase();
      var meta = SEATS[key] || {tribune:'Section '+cat, niveau:'Lower tier', porte:'A'};
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value,10)||1);
      if(!seatState || seatState.key !== key){ seatState = {key:key, bloc: meta.porte+rnd(5,10), rang: rnd(3,42), start: rnd(1,26)}; }
      var places=[]; for(var i=0;i<qty;i++){ places.push(seatState.start+i); }
      var pl = places.join(', ');
      if(props.Section) props.Section.value = meta.tribune;
      if(props.Level)   props.Level.value   = meta.niveau;
      if(props.Gate)    props.Gate.value    = 'Gate '+meta.porte;
      if(props.Block)   props.Block.value   = 'Block '+seatState.bloc;
      if(props.Row)     props.Row.value     = 'Row '+seatState.rang;
      if(props.Seats)   props.Seats.value   = pl+' (x'+qty+')';
      if(seatGrid){ seatGrid.innerHTML = srow('Section',meta.tribune)+srow('Level',meta.niveau)+srow('Gate','Gate '+meta.porte)+srow('Block','Block '+seatState.bloc)+srow('Row','Row '+seatState.rang)+srow('Seat'+(qty>1?'s':''),pl); }
      if(seatBox) seatBox.hidden = false;
      updateTotals();
    };
    var syncMap = function(){
      var cat = catOf(currentRadio()).toLowerCase();
      zones.forEach(function(z){ z.classList.toggle('is-selected', z.getAttribute('data-cat').toLowerCase()===cat); });
      legend.forEach(function(li){ li.classList.toggle('is-selected', (li.getAttribute('data-legend')||'').toLowerCase()===cat); });
    };
    var update = function(id){
      if(!id || !data[id]) return;
      if(idInput) idInput.value = id;
      var priced = money(data[id].price);
      priceEls.forEach(function(p){ var s=p.querySelector('small'); p.textContent=priced; if(s) p.appendChild(s); });
      var avail = data[id].available;
      submitBtns.forEach(function(b){ b.disabled=!avail; b.textContent = avail ? b.getAttribute('data-label') : 'Sold out'; });
      syncMap(); assignSeats();
    };

    pform.querySelectorAll('input[name="variant-radio"]').forEach(function(r){
      r.addEventListener('change', function(){ update(this.value); });
      if(r.checked) update(r.value);
    });
    if(qtyInput) qtyInput.addEventListener('change', assignSeats);

    // Quantité dans la barre d'achat sticky (synchronisée avec le formulaire)
    var buyQtyVal = document.querySelector('[data-buyqty-val]');
    var syncBuyQty = function(){ if(buyQtyVal && qtyInput) buyQtyVal.textContent = qtyInput.value; };
    document.querySelectorAll('[data-buyqty]').forEach(function(b){
      b.addEventListener('click', function(){
        if(!qtyInput) return;
        var step = b.getAttribute('data-buyqty') === '-' ? -1 : 1;
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value,10)||1) + step);
        qtyInput.dispatchEvent(new Event('change', { bubbles:true }));
        syncBuyQty();
      });
    });
    if(qtyInput) qtyInput.addEventListener('change', syncBuyQty);
    syncBuyQty();

    zones.forEach(function(z){
      z.style.cursor='pointer';
      var cat = z.getAttribute('data-cat').toLowerCase(), ok=false;
      pform.querySelectorAll('input[name="variant-radio"]').forEach(function(r){ if(catOf(r).toLowerCase()===cat && !r.disabled) ok=true; });
      if(!ok) z.classList.add('is-off');
      z.addEventListener('click', function(){
        var target=null;
        pform.querySelectorAll('input[name="variant-radio"]').forEach(function(r){ if(catOf(r).toLowerCase()===cat) target=r; });
        if(target && !target.disabled){ target.checked=true; update(target.value); if(seatBox) seatBox.scrollIntoView({behavior:'smooth',block:'nearest'}); }
      });
    });

    document.querySelectorAll('[data-add-proxy]').forEach(function(btn){
      btn.addEventListener('click', function(){ if(btn.disabled) return; if(typeof pform.requestSubmit==='function') pform.requestSubmit(); else pform.submit(); });
    });
  }

  /* ---------- Sélecteur de quantité ---------- */
  document.querySelectorAll('.qty').forEach(function(q){
    var input = q.querySelector('input');
    if (!input) return;
    q.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        var step = b.getAttribute('data-step') === '-' ? -1 : 1;
        var v = Math.max(1, (parseInt(input.value,10)||1) + step);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Révélations au scroll ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin:'0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }
})();
